
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import { configStore, documentStore, uiStore } from "@/store/store";
import Tab from "@/components/Reusable/Tabs/Tab.vue";
import TabsRow from "@/components/Reusable/Tabs/TabsRow.vue";
import { ControlsTreeContext } from "@/types/controls";
import SavePreset from "@/components/DesignLibrary/Presets/SavePreset.vue";
import { BuilderElementControls } from "@/types/elements";
import { findNode } from "@/lib/tree/tree";
import defensiveCopy from "@/util/defensive-copy";
import lodash from "lodash";
import { CONTROL_CLEAR_VALUE } from "@/lib/controls/values";
import Icon from "@/components/UI/Icon.vue";
import { getBuilderElementNameBySlug } from "@/lib/undo/snapshot-labels/document-store-property-change.utils";

@Component({
  components: {
    TabsRow,
    Tab,
    Icon,
    SavePreset
  }
})
export default class DesignContentSettingsTabs extends Vue {
  @Prop({
    default: "content"
  })
  value!: string;

  savePresetDialogOpen = false;

  @Prop()
  controls!: BuilderElementControls;

  setTab(tab: string) {
    this.$emit("input", tab);
  }

  get hasContentControls() {
    return this.controls.contentSections.length > 0;
  }

  get hasDesignControls() {
    return this.controls.designSections.length > 0;
  }

  get hasSettingsControls() {
    return this.controls.settingsSections.length > 0;
  }

  @Inject("context") readonly context!: ControlsTreeContext;

  resetToDefault(path: "design" | "content" | "settings") {
    if (uiStore.activeElement === false) return;
    resetElementProperties(uiStore.activeElement.id, path);
  }
}

function resetElementProperties(
  elementId: number,
  path: "design" | "content" | "settings"
) {
  const element = findNode(documentStore.document.tree, elementId);

  if (!element) return;

  const defaultProperties = configStore.element(element.data.type)
    .defaultProperties;

  /*
    Setting to undefined actually blows up VueSimpleDeepset
    when you then try to set a control value that has previously been cleared
    by this function. so we use null as a fallback
    */
  const defaultAtPath = lodash.get(
    defaultProperties,
    path,
    CONTROL_CLEAR_VALUE
  );

  documentStore.throttledPropertyChanged({
    elementId: element.id,
    path: path,
    value: defensiveCopy(defaultAtPath),
    meta: {
      snapshotLabel: `Reset ${getBuilderElementNameBySlug(
        element.data.type
      )} ${lodash.capitalize(path)}`
    }
  });
}
